import { render, staticRenderFns } from "./SerieSelector.vue?vue&type=template&id=67735478"
import script from "./SerieSelector.vue?vue&type=script&lang=js"
export * from "./SerieSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports